module.exports = __webpack_public_path__ + "static/media/xiaochengxu.81cc1257.png";